import { Injectable } from '@angular/core';

export const JSONRPC = '2.0';

export const EXPIRE_TIMES = {
    token: 3600 * 24 // 1 day
};

interface Config {
    dashboard: boolean;
    serverUrl: Origins;
    serverUrlXapi: newOrigins;
    dummyRequests: boolean;
};

type AllConfig = {
    [key in Origins]: Config
}

enum Origins {
    PRODUCTION = 'https://hss-be-prod.azurewebsites.net/',
    STAGE = 'https://hss-be-stage.azurewebsites.net/'
}

enum newOrigins {
    PRODUCTION_XAPI = 'https://xapi-hss.omnissimo.com/',
    STAGE_XAPI = 'https://stage-xapi-hss.omnissimo.com/'
}

@Injectable({
    providedIn: 'root'
})


export class ConfigService {
    private conditions: Config = {} as Config;
    private config: Config = {} as Config;

    private readonly allConfig: AllConfig = {
        [Origins.PRODUCTION]: {
            dummyRequests: false,
            serverUrl: Origins.PRODUCTION,
            serverUrlXapi: newOrigins.PRODUCTION_XAPI,
            dashboard: false
        },
        [Origins.STAGE]: {
            dummyRequests: false,
            serverUrl: Origins.STAGE,
            serverUrlXapi: newOrigins.STAGE_XAPI,
            dashboard: false
        },
    };

    constructor() {
        const url = `${window.location.origin}/` as Origins;
        this.config = this.allConfig[url] ?? this.allConfig[Origins.STAGE];
        this.conditions = JSON.parse(JSON.stringify(this.config));
    }

    public getOriginalDashboard(): boolean {
        return this.config.dashboard;
    }

    public getDashboard(): boolean {
        return this.conditions.dashboard;
    }

    public setDashboard(dashboard: boolean): void {
        this.conditions.dashboard = dashboard;
    }

    public getServerUrl(): string {
        return  this.conditions.serverUrl;
    }

    public getServerUrlXapi(): string {
        return this.conditions.serverUrlXapi;
    }

    public getDummyRequests(): boolean {
        return this.conditions.dummyRequests;
    }
}